<template>
  <a-card :bordered="false">
    <a-form-model
      ref="ruleForm"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
      :model="ruleForm"
      :rules="rules">
      <a-card :bordered="false" title="基本信息" :bodyStyle="{paddingTop:'0px'}"
              :headStyle="{borderBottom:'0px',fontSize:'18px'}">
        <a-form-model-item label="位置名称" prop="locationName">
          <a-input v-model="ruleForm.locationName" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="位置拼音" prop="locationPinyin">
          <a-input v-model="ruleForm.locationPinyin" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="宣传语" prop="slogan">
          <a-input v-model="ruleForm.slogan" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="经度" prop="longitude">
          <a-input v-model="ruleForm.longitude" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="纬度" prop="latitude">
          <a-input v-model="ruleForm.latitude" :maxLength="50" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="概况" prop="overview">
          <a-textarea v-model="ruleForm.overview" :maxLength="1000" placeholder="请输入" :rows="4"/>
        </a-form-model-item>
        <a-form-model-item label="背景图" prop="backgroundImage">
          <a-upload
            list-type="picture-card"
            class="avatar-uploader"
            :action="actionImageUrl"
            @change="handleChange"
            :before-upload="beforeUploadFile"
            :showUploadList="false"
          >
            <img v-if="ruleForm.backgroundImage" :src="ruleForm.backgroundImage" class="avatar" alt=""/>
            <a-icon v-else type="plus"/>
          </a-upload>
          <div style="color: red;">温馨提示：建议图片大小750px*400px，格式.jpg、.png、.jpeg</div>
        </a-form-model-item>
      </a-card>
      <template v-if="type==1">
        <a-card
          v-for="(item,index) in ruleForm.columns"
          :key="index"
          :bordered="false"
          title="推荐栏目"
          :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
          <a-form-model-item
            v-for="(subItem, subIndex) in item.items"
            :key="subIndex"
            :label-col="subIndex === 0 ?currentFormLayout.labelCol : {}"
            :wrapper-col="subIndex === 0 ?currentFormLayout.wrapperCol :  offsetWrapperCol"
            :label="subIndex === 0 ? '推荐商品' : ''"
          >
            <div style="display: flex;align-items: center">
              <a-input v-model="subItem.itemName" placeholder="栏目名" style="width: 100px; margin-right: 10px;"/>
              --
              <a-input v-model="subItem.itemContent" placeholder="商品ID，多个用英文,号隔开"
                       style="flex: 1;margin: 0 10px;"/>
              <a-icon
                v-if="item.items.length > 1"
                type="minus-circle-o"
                :disabled="item.items.length === 1"
                @click="deleteItem(subItem)"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="offsetWrapperCol">
            <a-button type="dashed" style="width: calc(100% - 24px)" @click="addItem">
              <a-icon type="plus"/>
              添加
            </a-button>
          </a-form-model-item>
        </a-card>

      </template>
      <div v-else>
        <a-card :bordered="false" v-for="(item,index) in ruleForm.columns" :key="index">
          <a-form-model-item :wrapper-col="{span: 10, offset: 2}">
            <a-input placeholder="栏目名称" style="width: 150px;margin-right: 10px;"
                     v-model="item.columnName"></a-input>
            <a-icon v-if="ruleForm.columns.length>1" type="delete" theme="twoTone" @click="deleteMenuItem(item)"/>
          </a-form-model-item>

          <a-form-model-item
            v-for="(subItem, subIndex) in item.items"
            :key="subIndex"
            :wrapper-col="{span: 16, offset: 3}"
          >
            <div style="display: flex;align-items: center">
              <a-input v-model="subItem.itemName" placeholder="名称" style="width: 100px; margin-right: 10px;"/>
              --
              <div style="flex: 1;margin: 0 10px;">
                <a-radio-group v-model="subItem.itemType" @change="e => onJumpChange(e,subItem)">
                  <a-radio :value="1">链接</a-radio>
                  <a-radio :value="2">小程序</a-radio>
                </a-radio-group>
                <a-input v-if="subItem.itemType==1" v-model="subItem.itemContent" placeholder="请输入链接"
                         style="width:100%"/>
                <div v-if="subItem.itemType==2">
                  <a-input v-model="subItem.appId" placeholder="请输入appId" style="width:100%"/>
                  <a-input v-model="subItem.itemContent" placeholder="请输入跳转路径" style="width:100%"/>
                </div>
              </div>
              <a-upload
                style="width: 40px;height: 40px;margin-right: 15px"
                list-type="picture-card"
                class="icon-uploader"
                :action="actionImageUrl"
                @change="(info)=>handleSubListChange(info,subItem)"
                :before-upload="beforeUploadFile"
                :showUploadList="false"
              >
                <img v-if="subItem.itemIcon" :src="subItem.itemIcon" class="icon" alt=""/>
                <a-icon v-else type="plus"/>
              </a-upload>
              <a-icon
                v-if="item.items.length>1"
                type="minus-circle-o"
                :disabled="item.items.length === 1"
                @click="deleteSubMenuItem(item,subItem)"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{span: 16, offset: 5}">
            <a-button type="dashed" style="width: calc(100% - 69px)" @click="addSubMenuItem(item,index)">
              <a-icon type="plus"/>
              添加
            </a-button>
          </a-form-model-item>
        </a-card>
        <a-form-model-item :wrapper-col="{span: 16, offset: 3}">
          <a-button style="margin: 20px 0" type="primary" icon="plus" ghost @click="addMenuItem">添加新栏目</a-button>
        </a-form-model-item>
      </div>
      <a-form-model-item :wrapper-col="offsetWrapperCol">
        <a-button :loading="submitLoading" type="primary" @click="handleSubmit()">提 交</a-button>
        <a-button style="margin-left: 10px;" @click="back">取 消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
<script>
export default {
  name: 'LocalDiscoveryAddOrEdit',
  data() {
    return {
      offsetWrapperCol: { span: 12, offset: 3 },
      currentFormLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 12 }
      },
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      id: this.$route.query.id,
      type: this.$route.query.type,
      ruleForm: {},
      rules: {
        locationName: [{ required: true, message: '请输入位置名称', trigger: 'change' }],
        locationPinyin: [{ required: true, message: '请输入位置拼音', trigger: 'change' }],
        slogan: [{ required: true, message: '请输入宣传语', trigger: 'change' }],
        longitude: [
          { required: true, message: '请输入经度', trigger: 'change' },
          { validator: this.validatorLongitude, trigger: 'change' }
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'change' },
          { validator: this.validatorLatitude, trigger: 'change' }
        ],
        overview: [{ required: true, message: '请输入概况', trigger: 'change' }],
        backgroundImage: [{ required: true, message: '请选择背景图', trigger: 'change' }]
      },
      submitLoading: false
    }
  },
  mounted() {
    this.initData()
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'DiscoveryManageList', title: '位置发现管理' }
    ])
  },
  methods: {
    initData() {
      if (this.id) {
        this.getDetailInfo()
      } else {
        let ruleForm = { ...this.ruleForm }
        ruleForm.columns = [
          {
            key: 0,
            columnName: '',
            items: []
          }
        ]
        this.ruleForm = ruleForm
      }
    },
    onJumpChange(e, subItem) {
      subItem.appId = ''
      subItem.itemContent = ''
    },
    getDetailInfo() {
      this.getHttpServices().getUserService().post('api/location/discovery/detail', {
        id: this.id
      }).then(res => {
        if (res) {
          this.ruleForm = JSON.parse(JSON.stringify(res))
          this.ruleForm.columns = this.dealColumnItemsData(this.ruleForm.columns)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    dealColumnItemsData(list) {
      if (list && list.length) {
        return list.map(item => {
          return {
            ...item,
            items: item.items && item.items.length ? item.items : []
          }
        })
      } else {
        return []
      }
    },
    validatorLongitude: (rule, itemName, callback) => {
      const reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,15})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,15}|180)$/
      if (itemName === '') {
        callback(new Error('请输入经度'))
      } else {
        if (!reg.test(itemName)) {
          callback(new Error('经度范围：-180~180（保留小数点后十五位）'))
        }
        callback()
      }
    },
    validatorLatitude: (rule, itemName, callback) => {
      const reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,15}|90\.0{0,15}|[0-8]?\d{1}|90)$/
      if (itemName === '') {
        callback(new Error('请输入纬度'))
      } else {
        if (!reg.test(itemName)) {
          callback(new Error('纬度范围：-90~90（保留小数点后十五位）'))
        }
        callback()
      }
    },
    addMenuItem() {
      const { columns } = this.ruleForm
      const nextKeys = columns && columns.length ? columns[columns.length - 1].key + 1 : 0
      this.ruleForm.columns = columns.concat({
        key: nextKeys,
        columnName: '',
        items: []
      })
    },
    deleteMenuItem(item) {
      const index = this.ruleForm.columns.indexOf(item)
      this.ruleForm.columns.splice(index, 1)
    },
    addSubMenuItem(item, index) {
      let { items } = item
      const nextKeys = items && items.length ? items[items.length - 1].key + 1 : 0
      item.items = items.concat({
        key: nextKeys,
        itemName: '',
        itemContent: '',
        itemIcon: '',
        itemType: 0,
        itemContent: '',
        appId: ''
      })
    },
    deleteSubMenuItem(item, subItem) {
      const index = item.items.indexOf(subItem)
      item.items.splice(index, 1)
    },
    addItem() {
      const { columns } = this.ruleForm
      const nextKeys = columns && columns.length ? columns[columns.length - 1].key + 1 : 0
      this.ruleForm.columns[0].items.push({
        key: nextKeys,
        itemName: '',
        itemContent: ''
      })
    },
    deleteItem(subItem) {
      const index = this.ruleForm.columns[0].items.indexOf(subItem)
      this.ruleForm.columns[0].items.splice(index, 1)
    },
    back() {
      this.$router.go(-1)
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    handleSubListChange(info, subItem) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        subItem.itemIcon = this.getLatestUrlFromFileList(info.fileList)
      }
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        const latestUrl = this.getLatestUrlFromFileList(info.fileList)
        this.$set(this.ruleForm, 'backgroundImage', latestUrl)
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let hasEmptyColumnName = false
          let hasShownColumnNameError = false

          this.ruleForm.columns.forEach(column => {
            if (!column.columnName) {
              hasEmptyColumnName = true
              if (!hasShownColumnNameError) {
                this.$message.error('请为每个栏目添加名称')
                hasShownColumnNameError = true
              }
            }
          })

          if (hasEmptyColumnName) {
            return
          }
          // 删除 items 中 itemName 为空的项
          this.ruleForm.columns.forEach(column => {
            column.items = column.items.filter(item => item.itemName)
          })
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.columns
      this.submitLoading = true
      if (this.id) {
        params.id = this.id
      }
      let url = this.id ? 'api/location/discovery/update' : 'api/location/discovery/add'
      this.getHttpServices().getUserService().post(url, params)
        .then(res => {
          this.$message.success('保存成功')
          this.submitLoading = false
          this.back()
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
          this.submitLoading = false
        })
    }
  }
}
</script>
<style scoped lang="less">
.avatar {
  border-radius: 4px;
  width: 100px;
  height: 100px;
}

.icon-uploader {
  .icon {
    border-radius: 2px;
    margin-right: 0;
    width: 32px;
    height: 32px;
  }
}
</style>
<style lang="less">
.icon-uploader {
  .ant-upload {
    padding: 1px !important;
    width: 40px !important;
    height: 40px !important;
    margin: 0 !important;
  }

  .icon {
    margin-right: 0;
  }
}
</style>